// Layouts
import DefaultLayout from '@/layouts/DefaultLayout.vue';

// Views
import NotFound from '@/views/404.vue';

// Routes
import ConnectRoutes from '@/router/routes/connect/index.connect';
import W2PRoutes from '@/router/routes/w2p/index.w2p';
import DashboardRoutes from '@/router/routes/dashboard.route';
import LoginRoutes from '@/router/routes/login.route';
import LogoutRoutes from '@/router/routes/logout.route';
import RegisterRoutes from '@/router/routes/register.route';
import ResetPasswordRoutes from '@/router/routes/reset-password.route';
import SettingsRoutes from '@/router/routes/settings.route';
import SupportRoutes from '@/router/routes/support.route';
import PublishArticle from '@/views/PublishArticle.vue';

const routes = [
  ...ConnectRoutes,

  DashboardRoutes,

  LoginRoutes,

  LogoutRoutes,

  RegisterRoutes,

  ResetPasswordRoutes,

  SettingsRoutes,

  SupportRoutes,

  ...W2PRoutes,

  { path: '/', redirect: '/login' },

  {
    path: '/connect/articles/publish',
    component: DefaultLayout,
    children: [
      {
        path: ':uuid',
        component: PublishArticle,
        meta: { auth: false }
      }
    ],
    meta: { auth: false }
  },

  {
    path: '*',
    component: DefaultLayout,
    children: [
      {
        path: '',
        component: NotFound,
        meta: {
          requiresAuth: false
        }
      }
    ]
  }
];

export default routes;
